// extracted by mini-css-extract-plugin
export default {"container":"footer_container__7mPGt","footerLabel":"footer_footerLabel__OwPxI"};